/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
import axios from 'axios';
import { verify } from 'crypto';

const nodemailer = require('nodemailer');
const hbs = require('nodemailer-express-handlebars');

const PsychometricService = {

  updateUser: (id, updatedUser) => {
    return axios.put(`/api/psychometric-test/update-candidate/${id}`, updatedUser)
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  getFilteredOrganizations: async (limit, page, searchVal) => {
    try {
      const response = await axios.get('/api/psychometric-test/get-filtered-organizations', {
        params: { limit, page, searchVal },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  getFilteredUsers: async (limit, page, searchVal) => {
    try {
      const response = await axios.get('/api/psychometric-test/get-filtered-users', {
        params: { limit, page, searchVal },
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  createCandidate: async (uniqueID, firstName, lastName, gender, email, organization) => {
    try {
      const response = await axios.post('/api/psychometric-test/create-candidate', { 
        uniqueID,
        firstName, 
        lastName, 
        gender,
        email,
        organization 
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  
  updateOrganization: (id, updatedOrganization) => {
    return axios.put(`/api/psychometric-test/update-organization/${id}`, updatedOrganization)
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  deleteCandidate: (id) => {
    return axios.delete(`/api/psychometric-test/delete-candidate/${id}`)
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  deleteOrganization: (id) => {
    return axios.delete(`/api/psychometric-test/delete-organization/${id}`)
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  getUserOrganizationEmail: (uniqueID,firstName, lastName,organization) => { 
    return axios.get('/api/psychometric-test/organization-email', { params: { uniqueID,firstName, lastName, organization } })
      .then(res => res.data)  
      .catch(err => {
        throw err.response.data;
      }); 
  },
  getOrganizations: () => {
    return axios.get('/api/psychometric-test/get-organizations')
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },

  getUsers: () => {
    return axios.get('/api/psychometric-test/get-users')
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },

  createOrganization: (name, email, mobile, address, city, state, country, logo, website, password) => {
    return axios.post('/api/psychometric-test/create-organization', {name, email, mobile, address, city, state, country, logo, website, password })
    .then(res => res.data)
    .catch(err => {
      throw err.response.data;
    });
  },

  updateUserOrganizationInfo: async (uniqueID, firstName, lastName, organization) => {
    try {
      const response = await axios.post('/api/psychometric-test/update-user-org-info', {
        uniqueID,
        firstName,
        lastName,
        organization
      });
      return response.data;
    } catch (error) {
      throw error.response?.data;
    }
  },

  getPsychometricTest: (testLanguage) => {
    return axios.get('/api/psychometric-test/test', { params: { testLanguage } })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  getPsychometricOrganization: (email) => {
    return axios.get('/api/psychometric-test/organization', {
        params: { candidateEmail: email }
    })
    .then(res => res.data)
    .catch(err => {
        throw err.response.data;
    });
  },
  getPsychometricUser: (uniqueID, firstName, lastName, organization) => {
    const params = {
      candidateID: uniqueID.trim(),
      candidateFirstName: firstName.trim(),
      candidateLastName: lastName.trim(),
      candidateOrganization: organization.trim()
    };

    return axios.get('/api/psychometric-test/user', { params })
      .then(res => res.data)
      .catch(err => {
        throw err.response?.data;
      });
  },

  getPsychometricIndividual: (email) => {
    const decodedEmail = decodeURIComponent(email);
    
    return axios.get('/api/psychometric-test/individual', { params: {candidateEmail: decodedEmail} })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },

  updateTraitsAnswers: (uniqueID,firstName, lastName, organization, questionIndex, answer) => {
    return axios.post('/api/psychometric-test/update-traits-answers', {
      uniqueID,
      firstName,
       lastName,
      organization,
      questionIndex,
      answer
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateIndividualTraitsAnswers: (email, questionIndex, answer) => {
    const decodedEmail = decodeURIComponent(email);
    return axios.post('/api/psychometric-test/update-individual-traits-answers', {
      email: decodedEmail,
      questionIndex,
      answer
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateSkillsAnswers: (uniqueID,firstName, lastName, organization, questionIndex, answer) => {
    return axios.post('/api/psychometric-test/update-skills-answers', {
      uniqueID,
      firstName, 
      lastName,
      organization,
      questionIndex,
      answer
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateIndividualSkillsAnswers: (email, questionIndex, answer) => {
    const decodedEmail = decodeURIComponent(email);
    return axios.post('/api/psychometric-test/update-individual-skills-answers', {
      email: decodedEmail,
      questionIndex,
      answer
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateInterestsAnswers: ({ uniqueID,firstName, lastName, organization, sectionLetter, checkedIndex, checked }) => {
    
    return axios.post('/api/psychometric-test/update-interests-answers', {
      uniqueID,
      firstName, 
      lastName,
      organization,
      sectionLetter,
      checkedIndex,
      checked
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateIndividualInterestsAnswers: ({ email, sectionLetter, checkedIndex, checked }) => {
    const decodedEmail = decodeURIComponent(email);
    return axios.post('/api/psychometric-test/update-individual-interests-answers', {
      email: decodedEmail,
      sectionLetter,
      checkedIndex,
      checked
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },

  updateTraitsScores: (uniqueID,firstName, lastName,organization) => {
    return axios.post('/api/psychometric-test/update-traits-scores', {
      uniqueID,
      firstName,
       lastName,
      organization,
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateIndividualTraitsScores: (email) => {
    const decodedEmail = decodeURIComponent(email);
    return axios.post('/api/psychometric-test/update-individual-traits-scores', {
      email: decodedEmail
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateSkillsScores: (uniqueID,firstName, lastName, organization) => {
    return axios.post('/api/psychometric-test/update-skills-scores', {
      uniqueID,
      firstName, 
      lastName,
      organization,
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateIndividualSkillsScores: (email) => {
    const decodedEmail = decodeURIComponent(email);
    return axios.post('/api/psychometric-test/update-individual-skills-scores', {
      email: decodedEmail
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },

  updateInterestsScores: (uniqueID,firstName, lastName, organization) => {
    return axios.post('/api/psychometric-test/update-interests-scores', {
      uniqueID,
      firstName, 
      lastName,
      organization,
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  updateIndividualInterestsScores: (email) => {
    const decodedEmail = decodeURIComponent(email);
    return axios.post('/api/psychometric-test/update-individual-interests-scores', {
      email: decodedEmail
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  // send report to candidate
  sendReport: (uniqueID,firstName, lastName, organization, organizationEmail, pdfData) => {
    return axios.post('/api/psychometric-test/send-report',  {
      uniqueID,
      firstName, 
      lastName,
      organization,
      organizationEmail,
      pdfData
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },

  sendIndividualReport: (email, pdfData) => {
    const decodedEmail = decodeURIComponent(email);
    return axios.post('/api/psychometric-test/send-individual-report',  {
      email: decodedEmail,
      pdfData
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },


  signUpOrganization: (name, email, mobile, address, city, state, country, website, password) => {
    return axios.post('/api/psychometric-test/sign-up-organization', {name, email, mobile, address, city, state, country, website, password })
    .then(res => res.data)
    .catch(err => {
      throw err.response.data;
    });
},
/*
  sendReport: (mobile, email, organization, pdfData) => {
    const data = new FormData();
    data.append('mobile', mobile);
    data.append('email', email);
    data.append('organization', organization);
    data.append('pdfData', pdfData);
    return axios.post('/api/psychometric-test/send-report', data , {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
      }
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  }, */
  getUsersOrg: async (organization, page = 1, limit = 10) => {
    try {
      const response = await axios.get(`/api/psychometric-test/get-users-organization?organization=${organization}&page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  
  getFilteredUsersOrg: async (organization, page = 1, limit = 10, searchVal) => {
    try {
      const response = await axios.get(`/api/psychometric-test/get-filtered-users-organization?organization=${organization}&page=${page}&limit=${limit}&searchVal=${searchVal}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Sign in organization
  signInOrganization: async (email, password) => {
    try {
      const response = await axios.post('/api/psychometric-test/sign-in-organization', { email, password });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

    // Sign in individual
    signInIndividual: async (email, password, otpData = null) => {
      try {
        const response = await axios.post('/api/psychometric-test/sign-in-individual', { 
          email, 
          password,
          ...otpData // This will include isTwoFactor and otp if provided
        });
        return response.data;
      } catch (error) {
        throw error.response?.data || error;
      }
    },
  
  updateOrganizationByDetails: (name, email, updatedOrganization) => {
    return axios.put('/api/psychometric-test/update-org-details', { name, email, ...updatedOrganization })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },

  updateIndividualByDetails: ( email, updatedIndividual) => {
    return axios.put('/api/psychometric-test/update-individual-details', {  email, ...updatedIndividual })
      .then(res => res.data)
      .catch(err => {
        throw err.response.data;
      });
  },
  signUpOrganization: async (name, email, mobile, address, city, state, country, website, password) => {
    try {
      const response = await axios.post('/api/psychometric-test/sign-up-psychometric-organization', {
        name, 
        email, 
        mobile, 
        address, 
        city, 
        state, 
        country, 
        website, 
        password
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  
  signUpIndividual: async (firstName, lastName, email, mobile, password) => {
    try {
      const response = await axios.post('/api/psychometric-test/sign-up-psychometric-individual', {
        firstName, 
        lastName,
        email, 
        mobile, 
        password
      });
      
      return response.data;
    } catch (error) {
      throw error.response?.data || {
        message: {
          msgBody: error.message || "Network error occurred",
          msgError: true
        }
      };
    }
  },

  checkId: async (uniqueID) => {
    try {
      const response = await axios.get(`/api/psychometric-test/check-id/${uniqueID}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  getUserOrganization: (uniqueID, firstName, lastName) => {
    const params = {
      candidateID: uniqueID.trim(),
      candidateFirstName: firstName.trim(),
      candidateLastName: lastName.trim()
    };

    return axios.get('/api/psychometric-test/get-user-organization', { params })
      .then(res => res.data)
      .catch(err => {
        throw err.response?.data;
      });
  },

  requestPasswordReset: async (email, userType) => {
    try {
        const response = await axios.post('/api/psychometric-test/forgot-password/request', {
            email,
            userType
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
},

verifyResetToken: async (email, resetToken, newPassword, userType) => {
    try {
        const response = await axios.post('/api/psychometric-test/forgot-password/verify', {
            email,
            resetToken,
            newPassword,
            userType
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
},

markTestComplete: async (uniqueID, firstName, lastName, organization, email) => {
  try {
    const requestBody = email ? 
      { email } : 
      { 
        uniqueID: uniqueID.trim(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        organization: organization.trim()
      };

    const response = await axios.post('/api/psychometric-test/mark-test-complete', requestBody);
    return response.data;
  } catch (error) {
    throw error.response?.data;
  }
},

checkTestCompletion: async (uniqueID, firstName, lastName, organization, email) => {
  try {
    // Build query params based on user type
    const params = email ? 
      { email } : 
      { 
        uniqueID: uniqueID.trim(),
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        organization: organization.trim()
      };

    const response = await axios.get('/api/psychometric-test/check-test-completion', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || {
      message: { msgBody: "Failed to check test completion", msgError: true }
    };
  }
},

// Add new service function
sendUserCodeEmail: async (userId) => {
  try {
    const response = await axios.post('/api/psychometric-test/send-user-code', { userId });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
},

// Add new service function
verifyTestTakerOTP: async (uniqueID, firstName, lastName, otp) => {
  try {
    const response = await axios.post('/api/psychometric-test/verify-test-taker-otp', { 
      uniqueID, 
      firstName, 
      lastName,
      otp 
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
},

// Add new service function
sendTestTakerOTP: async (uniqueID, firstName, lastName) => {
  try {
    const response = await axios.post('/api/psychometric-test/send-test-taker-otp', { 
      uniqueID, 
      firstName, 
      lastName 
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
},

handleOrganizationPrivacy: async (organizationName, action) => {
  try {
    const response = await axios.post('/api/psychometric-test/handle-org-privacy', {
      organizationName,
      action // 'remove' or 'keep'
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
},

sendOTPToPhone: async (email) => {
    try {
        const response = await axios.post('/api/psychometric-test/send-otp-to-phone', {
            email
        });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
},
};
export default PsychometricService;